import React from 'react';

/**
 * A payment's receipt / refund voucher number (PMS Phase 2 slice 4).
 *   ISSUED   the number
 *   PENDING  the property is not linked to an accounting entity / financial year
 *            yet — numbered later from Document Series
 *   EXTERNAL recorded by Accounts in Fairbooks; the voucher is theirs
 *   none     recorded before numbering existed
 */
interface Props {
  receiptNumber?: string | null;
  state?: string | null;
}

const ReceiptNumber: React.FC<Props> = ({ receiptNumber, state }) => {
  if (state === 'ISSUED' && receiptNumber)
    return <span style={{ fontFamily: 'monospace', fontSize: '0.8rem' }} title="Receipt voucher number">{receiptNumber}</span>;
  if (state === 'PENDING')
    return (
      <span className="badge badge-warning" style={{ fontSize: '0.7rem' }}
        title="The property is not linked to an accounting entity with a financial year yet. Issue the number from Document Series once it is.">
        Number pending
      </span>
    );
  if (state === 'EXTERNAL')
    return <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }} title="Recorded by Accounts — the receipt voucher is issued in Fairbooks">Fairbooks voucher</span>;
  return <span style={{ color: 'var(--text-muted)' }}>—</span>;
};

export default ReceiptNumber;
